import React from 'react';
import BaseTable from './BaseTable';

const InRereview = () => {
  const tableHeaders = [
    "",
    "Entered Peer Rereview",
    "Channel",
    "Author",
    "Title",
    "Reviews",
    "History"
  ]

  const rowNames = [
    "checkbox",
    "most_recent_activity",
    "channel_name",
    "admin_user_link",
    "title",
    "review_balls",
    "reminder_history"
  ]

  const columnAmountAndWidths = [
    {width: '50px', class: 'centered'},
    {width: '180px'},
    null,
    {width: '160px'},
    null,
    {width: '100px'},
    {width: '100px', class: 'centered'}
  ]

  return <BaseTable
          tableHeaders={tableHeaders}
          state={"in_rereview"}
          rowNames={rowNames}
          historyElementColumnIndex={6}
          removeOrderingColumn={[0,6]}
          columnAmountAndWidths={columnAmountAndWidths}
          enableEmailReminder={true}
          emailTemplateName={"InRereview"}
          />
}

export default InRereview;